import * as React from "react";
const SvgChevronDownFill = props => <svg xmlns="http://www.w3.org/2000/svg" width={10} height={9} fill="none" viewBox="0 0 10 9" {...props}><path d="M4.795 8.38.136.31h9.317z" /></svg>;
export { SvgChevronDownFill as ReactComponent };